module.exports = __webpack_public_path__ + "img/vsh.37c22442.png";